import { render, staticRenderFns } from "./SelectBookDialog.vue?vue&type=template&id=156a2bd3&scoped=true"
import script from "./SelectBookDialog.vue?vue&type=script&lang=js"
export * from "./SelectBookDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectBookDialog.vue?vue&type=style&index=0&id=156a2bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a2bd3",
  null
  
)

export default component.exports